import React from 'react';
import Modal from '../../../../components/Modal';
import { Button } from '../../../../components';
import { InitialsAvatar } from '../shared';
import { useDutyRoster } from '../DutyRosterContext';

const ReviewListModal = () => {
    const { reviewListOpen, setReviewListOpen, shortDays, collectReviews, openReview } = useDutyRoster();
    return (
            <Modal
                isOpen={!!reviewListOpen}
                onClose={() => setReviewListOpen(null)}
                title="Items needing review"
                maxWidth="max-w-[620px]"
            >
                {reviewListOpen && (() => {
                    const items = collectReviews(reviewListOpen.scope, reviewListOpen.group);
                    const fullMonths = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
                    if (items.length === 0) {
                        return <p className="text-[13px] text-[#94A3B8] dark:text-gray-500 py-6 text-center">Nothing needs review here. 🎉</p>;
                    }
                    return (
                        <div className="space-y-2 pt-1">
                            <p className="text-[12px] text-[#64748B] dark:text-gray-400 mb-1">
                                {items.length} item{items.length === 1 ? '' : 's'} need review
                                {reviewListOpen.group ? ` in ${reviewListOpen.group.name}` : ''}.
                            </p>
                            <ul className="space-y-2 max-h-[60vh] overflow-y-auto pr-1">
                                {items.map((it, i) => {
                                    const isMissed = it.kind === 'missed';
                                    return (
                                        <li key={`${it.emp.id}-${it.date.toISOString()}-${i}`}
                                            className={`flex items-center gap-3 px-3 py-2.5 rounded-xl border ${isMissed ? 'border-rose-200 dark:border-red-900/50 bg-rose-50/50 dark:bg-red-900/10' : 'border-amber-200 dark:border-amber-900/50 bg-amber-50/50 dark:bg-amber-900/10'}`}>
                                            <InitialsAvatar name={it.emp.name} size="md" />
                                            <div className="min-w-0 flex-1">
                                                <p className="text-[13px] font-bold text-[#1E293B] dark:text-gray-200 truncate">{it.emp.name}</p>
                                                <p className="text-[11px] text-[#64748B] dark:text-gray-400">
                                                    {it.group.name} · {shortDays[it.date.getDay()]} {it.date.getDate()} {fullMonths[it.date.getMonth()]}
                                                </p>
                                            </div>
                                            <span className={`text-[9px] font-extrabold uppercase tracking-wide px-2 py-1 rounded ${isMissed ? 'bg-rose-100 dark:bg-red-900/10 text-rose-700 dark:text-red-400' : 'bg-amber-100 dark:bg-amber-900/10 text-amber-700 dark:text-amber-400'}`}>
                                                {isMissed ? 'Missed' : 'Differs'}
                                            </span>
                                            <Button
                                                variant="primary"
                                                size="sm"
                                                onClick={() => { setReviewListOpen(null); openReview(it.emp, it.date, it.dayShift, it.kind, it.group); }}
                                            >
                                                Review
                                            </Button>
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>
                    );
                })()}
            </Modal>
    );
};

export default ReviewListModal;
